<script lang="ts">
	import CardNew from '@/components/Cards/CardNew.svelte';
	import type { ListingsResponse } from '@/pocketbase/pocketbase-types';

	type RelatedListing = ListingsResponse & {
		minPriceFromRanges?: number | null;
	};

	let {
		relatedListings = [],
		locationLabel = null
	}: {
		relatedListings?: RelatedListing[];
		locationLabel?: string | null;
	} = $props();

	const subtitle = $derived(
		locationLabel
			? `Alquileres y experiencias activas en ${locationLabel}`
			: 'Alquileres y experiencias activas en esta zona'
	);
</script>

{#if relatedListings.length > 0}
	<section
		class="border-t border-gray-200 bg-white py-10 md:py-12"
		aria-labelledby="related-listings-heading"
	>
		<div class="mx-auto max-w-7xl px-4 md:px-8">
			<div class="mb-6 space-y-1 md:mb-8">
				<h2
					id="related-listings-heading"
					class="text-balance text-xl font-semibold tracking-tight text-gray-900 md:text-2xl"
				>
					También puedes zarpar desde esta zona
				</h2>
				<p class="text-pretty text-base text-gray-600 sm:text-sm/6">{subtitle}</p>
			</div>

			<div class="grid grid-cols-2 gap-x-1 gap-y-4 md:gap-4 xl:grid-cols-4">
				{#each relatedListings as listing (listing.id)}
					<CardNew
						listing={listing}
						minPriceFromRanges={listing.minPriceFromRanges}
						aspectRatio="portrait"
						width={300}
						height={400}
					/>
				{/each}
			</div>
		</div>
	</section>
{/if}
